

{
  "familyId": "REK-CONTEXT-MEERSTAPS",
  "questions": [
    {
      "id": "REK-CONTEXT-MEERSTAPS-001",
      "familyId": "REK-CONTEXT-MEERSTAPS",
      "module": "Basisrekenen",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_meerstaps",
      "questionType": "step_solver",
      "question": "Een cateraar bereidt lunch voor 85 personen. Elk broodje kost €1,80 en elke persoon krijgt 2 broodjes. Daarnaast bestelt ze 10 flessen sap van €3,50 per fles. Wat zijn de totale kosten?",
      "context": null,
      "options": [],
      "correctAnswer": "341",
      "data": {
        "stepSolver": {
          "context": "85 personen, 2 broodjes p.p. à €1,80, 10 flessen sap à €3,50",
          "steps": [
            {
              "prompt": "Hoeveel broodjes zijn er in totaal nodig? (85 personen × 2 broodjes)",
              "correctAnswer": "170",
              "acceptedAnswers": ["170"],
              "hint": "Elke persoon krijgt 2 broodjes: 85 × 2"
            },
            {
              "prompt": "Wat kosten alle broodjes samen? (170 × €1,80)",
              "correctAnswer": "306",
              "acceptedAnswers": ["306", "€306", "€ 306"],
              "hint": "170 broodjes × €1,80 per stuk"
            },
            {
              "prompt": "Wat kosten de 10 flessen sap? (10 × €3,50)",
              "correctAnswer": "35",
              "acceptedAnswers": ["35", "€35", "€ 35"],
              "hint": "10 flessen × €3,50 per fles"
            },
            {
              "prompt": "Wat zijn de totale kosten? (broodjes + sap)",
              "correctAnswer": "341",
              "acceptedAnswers": ["341", "€341", "€ 341"],
              "hint": "€306 + €35"
            }
          ],
          "showStepsProgressively": true
        }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Meerstaps: splits in deelproblemen",
            "content": "Stap 1: Hoeveel broodjes? 85 × 2 = 170. Stap 2: Kosten broodjes? 170 × €1,80 = €306. Stap 3: Kosten sap? 10 × €3,50 = €35. Stap 4: Totaal? €306 + €35 = €341. Tip: maak een plan vóór je gaat rekenen!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_meerstaps_kosten",
      "variantIndex": 1,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.82,
      "feedback": {
        "explanationText": "Stap 1: Aantal broodjes = 85 × 2 = 170. Stap 2: Kosten broodjes = 170 × €1,80 = €306. Stap 3: Kosten sap = 10 × €3,50 = €35. Stap 4: Totaal = €306 + €35 = €341. Bij meerstaps-opgaven: maak eerst een plan, reken dan stap voor stap.",
        "solutionSteps": [
          "Stap 1: Aantal broodjes = 85 × 2 = 170",
          "Stap 2: Kosten broodjes = 170 × €1,80 = €306",
          "Stap 3: Kosten sap = 10 × €3,50 = €35",
          "Stap 4: Totaal = €306 + €35 = €341 ✓"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "hasStructuredData": true
      }
    },
    {
      "id": "REK-CONTEXT-MEERSTAPS-002",
      "familyId": "REK-CONTEXT-MEERSTAPS",
      "module": "Basisrekenen",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_meerstaps",
      "questionType": "multiple_choice",
      "question": "Een school organiseert een uitje voor 124 leerlingen. Er gaan bussen met 45 zitplaatsen. Elke bus kost €275. Hoeveel kost het busvervoer in totaal?",
      "context": null,
      "options": ["€550", "€750", "€825", "€1.100"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Eerst: hoeveel bussen? Dan: kosten",
            "content": "Stap 1: Hoeveel bussen? 124 ÷ 45 = 2,75... → je hebt 3 bussen nodig (naar boven afronden!). Stap 2: Kosten = 3 × €275 = €825. Let op: bij 'hoeveel nodig' rond je ALTIJD naar boven af!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_meerstaps_afronden_boven",
      "variantIndex": 2,
      "citoDifficulty": 0.56,
      "citoDiscrimination": 0.84,
      "feedback": {
        "explanationText": "Stap 1: 124 ÷ 45 = 2,75... → je hebt 3 bussen nodig (naar boven afronden!). Stap 2: 3 × €275 = €825. Let op: bij 'hoeveel nodig' rond je altijd naar boven af — je kunt geen 0,75 bus bestellen.",
        "solutionSteps": [
          "Stap 1: 124 ÷ 45 = 2,75...",
          "Stap 2: Naar boven afronden → 3 bussen",
          "Stap 3: 3 × €275 = €825 ✓"
        ],
        "distractorExplanations": {
          "0": "Je rondde af naar 2 bussen. Maar 2 × 45 = 90 zitplaatsen — niet genoeg voor 124 leerlingen! Je hebt 3 bussen nodig: 3 × €275 = €825.",
          "1": "Je dacht 3 × €250 = €750. Maar elke bus kost €275, niet €250. 3 × €275 = €825.",
          "2": "Goed! 3 bussen × €275 = €825. Je rondde correct naar boven af.",
          "3": "Je dacht 4 bussen × €275 = €1.100. Maar 3 bussen × 45 = 135 zitplaatsen — dat is genoeg voor 124 leerlingen."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "rek.afronden-beneden-ipv-boven", "label": "Naar beneden afgerond i.p.v. naar boven", "optionIndex": 0 },
          { "id": "rek.verkeerd-bedrag-gebruikt", "label": "Verkeerd bedrag per bus", "optionIndex": 1 },
          { "id": "rek.te-veel-eenheden", "label": "Te veel bussen berekend", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-CONTEXT-MEERSTAPS-003",
      "familyId": "REK-CONTEXT-MEERSTAPS",
      "module": "Basisrekenen",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_meerstaps",
      "questionType": "multiple_choice",
      "question": "Een schilder schildert 3 kamers. Kamer 1 is 4 × 5 meter, kamer 2 is 3 × 6 meter en kamer 3 is 4 × 4 meter. Een blik verf dekt 10 m². Hoeveel blikken verf heeft ze minimaal nodig?",
      "context": null,
      "options": ["5 blikken", "6 blikken", "7 blikken", "4 blikken"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Oppervlakte berekenen, dan delen",
            "content": "Stap 1: Oppervlaktes: 4×5=20, 3×6=18, 4×4=16 m². Stap 2: Totaal = 20+18+16 = 54 m². Stap 3: 54 ÷ 10 = 5,4 → naar boven afronden = 6 blikken. Je kunt geen 0,4 blik kopen!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_meerstaps_oppervlakte",
      "variantIndex": 3,
      "citoDifficulty": 0.58,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "Stap 1: Oppervlaktes: 4 × 5 = 20, 3 × 6 = 18, 4 × 4 = 16 m². Stap 2: Totaal = 20 + 18 + 16 = 54 m². Stap 3: 54 ÷ 10 = 5,4 → naar boven afronden = 6 blikken. Bij 'minimaal nodig' rond je altijd naar boven af.",
        "solutionSteps": [
          "Kamer 1: 4 × 5 = 20 m²",
          "Kamer 2: 3 × 6 = 18 m²",
          "Kamer 3: 4 × 4 = 16 m²",
          "Totaal: 20 + 18 + 16 = 54 m²",
          "54 ÷ 10 = 5,4 → 6 blikken nodig ✓"
        ],
        "distractorExplanations": {
          "0": "Je rondde 5,4 af naar beneden (5). Maar met 5 blikken dek je maar 50 m² — niet genoeg voor 54 m². Je hebt 6 blikken nodig.",
          "1": "Goed! 54 m² ÷ 10 = 5,4 → 6 blikken nodig.",
          "2": "7 blikken is te veel. 54 ÷ 10 = 5,4, dus 6 blikken is genoeg (6 × 10 = 60 m² > 54 m²).",
          "3": "Je vergat waarschijnlijk een kamer. Alle drie kamers: 20 + 18 + 16 = 54 m², niet 40 m². 54 ÷ 10 = 5,4 → 6 blikken."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "rek.afronden-beneden-ipv-boven", "label": "Naar beneden afgerond i.p.v. naar boven", "optionIndex": 0 },
          { "id": "rek.te-veel-eenheden", "label": "Te veel blikken berekend", "optionIndex": 2 },
          { "id": "rek.deelprobleem-vergeten", "label": "Een kamer vergeten mee te tellen", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-CONTEXT-MEERSTAPS-004",
      "familyId": "REK-CONTEXT-MEERSTAPS",
      "module": "Basisrekenen",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_meerstaps",
      "questionType": "multiple_choice",
      "question": "Een winkelier koopt 50 T-shirts in voor €8 per stuk. Ze verkoopt er 35 voor €15 per stuk. De rest verkoopt ze in de uitverkoop voor €6 per stuk. Hoeveel winst maakt ze in totaal?",
      "context": null,
      "options": ["€125", "€315", "€175", "€215"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Winst = opbrengst − kosten",
            "content": "Stap 1: Inkoopkosten = 50 × €8 = €400. Stap 2: Opbrengst normaal = 35 × €15 = €525. Stap 3: Opbrengst uitverkoop = 15 × €6 = €90. Stap 4: Totale opbrengst = €525 + €90 = €615. Stap 5: Winst = €615 − €400 = €215.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_meerstaps_winst",
      "variantIndex": 4,
      "citoDifficulty": 0.62,
      "citoDiscrimination": 0.82,
      "feedback": {
        "explanationText": "Stap 1: Inkoop = 50 × €8 = €400. Stap 2: Opbrengst normaal = 35 × €15 = €525. Stap 3: Uitverkoop = 15 × €6 = €90. Stap 4: Totale opbrengst = €525 + €90 = €615. Stap 5: Winst = €615 − €400 = €215.",
        "solutionSteps": [
          "Inkoop: 50 × €8 = €400",
          "Opbrengst normaal: 35 × €15 = €525",
          "Uitverkoop: (50 − 35) = 15 shirts × €6 = €90",
          "Totale opbrengst: €525 + €90 = €615",
          "Winst: €615 − €400 = €215 ✓"
        ],
        "distractorExplanations": {
          "0": "Je vergat de uitverkoop-opbrengst. Alleen normaal: €525 − €400 = €125. Maar er zijn ook 15 shirts voor €6 verkocht: +€90. Totaal: €525 + €90 − €400 = €215.",
          "1": "Je berekende waarschijnlijk 50 × €15 = €750, min €400 = €350. Maar niet alle shirts zijn voor €15 verkocht — 15 stuks gingen voor €6. Totale opbrengst: €525 + €90 = €615. Winst: €215.",
          "2": "Je berekende alleen de winst op de normale verkoop: 35 × (€15 − €8) = €245. Maar de 15 uitverkoop-shirts kosten €8 maar leveren €6 op → verlies van €2 per stuk. Totaal: €245 − €30 = €215.",
          "3": "Goed! Opbrengst €615 − inkoop €400 = €215 winst."
        }
      },
      "pedagogy": {
        "dok": 4,
        "misconceptionTags": [
          { "id": "rek.deelprobleem-vergeten", "label": "Uitverkoop-opbrengst vergeten", "optionIndex": 0 },
          { "id": "rek.verkeerde-aanname", "label": "Aangenomen dat alle shirts voor dezelfde prijs verkocht", "optionIndex": 1 },
          { "id": "rek.deelprobleem-vergeten", "label": "Verlies op uitverkoop niet meegeteld", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "REK-CONTEXT-MEERSTAPS-005",
      "familyId": "REK-CONTEXT-MEERSTAPS",
      "module": "Basisrekenen",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_meerstaps",
      "questionType": "multiple_choice",
      "question": "Een magazijnmedewerker moet 864 pakketjes verdelen over 3 vrachtwagens. Elke vrachtwagen heeft 12 pallets en op elke pallet passen 24 pakketjes. Passen alle pakketjes in de vrachtwagens?",
      "context": null,
      "options": [
        "Nee, er passen maar 720 pakketjes",
        "Nee, er passen maar 840 pakketjes",
        "Ja, precies — 3 × 12 × 24 = 864",
        "Ja, er is zelfs ruimte over voor 36 extra pakketjes"
      ],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Capaciteit berekenen: stap voor stap",
            "content": "Stap 1: Pakketjes per vrachtwagen = 12 pallets × 24 pakketjes = 288. Stap 2: Totale capaciteit = 3 × 288 = 864. Stap 3: Vergelijk: 864 pakketjes = 864 capaciteit → past precies!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_meerstaps_capaciteit",
      "variantIndex": 5,
      "citoDifficulty": 0.54,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Stap 1: Per vrachtwagen: 12 × 24 = 288 pakketjes. Stap 2: Totaal: 3 × 288 = 864. Stap 3: 864 = 864 → past precies! Bij dit soort opgaven bereken je eerst de totale capaciteit en vergelijk je die met het aantal.",
        "solutionSteps": [
          "Per vrachtwagen: 12 × 24 = 288 pakketjes",
          "Totale capaciteit: 3 × 288 = 864",
          "Vergelijk: 864 pakketjes = 864 capaciteit → past precies ✓"
        ],
        "distractorExplanations": {
          "0": "Je berekende 3 × 12 × 20 = 720. Maar er passen 24 pakketjes per pallet, niet 20. 3 × 12 × 24 = 864.",
          "1": "Controleer je berekening: 12 × 24 = 288, dan 3 × 288 = 864 (niet 840).",
          "2": "Goed! 3 × 12 × 24 = 864. Alle pakketjes passen precies.",
          "3": "Je berekende 3 × 12 × 25 = 900, dus 900 − 864 = 36 over. Maar er passen 24 pakketjes per pallet, niet 25. 3 × 12 × 24 = 864 — precies genoeg."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "rek.verkeerd-getal-gebruikt", "label": "Verkeerd aantal per pallet (20 i.p.v. 24)", "optionIndex": 0 },
          { "id": "rek.rekenfout-vermenigvuldigen", "label": "Rekenfout bij vermenigvuldigen", "optionIndex": 1 },
          { "id": "rek.verkeerd-getal-gebruikt", "label": "Verkeerd aantal per pallet (25 i.p.v. 24)", "optionIndex": 3 }
        ]
      }
    }
  ]
}

